import { CompetencyQuestion } from 'src/constants/voicebox';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const setModelCompetencyQuestions =
  (competencyQuestions: CompetencyQuestion[]) => (model: Model) => {
    setDataProperty<ModelData>(model)(
      model.modelData,
      'competencyQuestions',
      competencyQuestions
    );
  };
